export default __webpack_public_path__ + "static/media/rule.5ef89056.svg";